// nodejs library to set properties for components
import PropTypes from "prop-types";
import styles from "../../assets/jss/material-dashboard-react/components/cardAvatarStyle.js";
import { getBaseSxStyle, getKeyArray } from "../../utils/getSxStyle.js";
import { Box } from "@mui/material";

export default function CardAvatar(props) {
  const { children, className, plain, profile, ...rest } = props;

  const targetData = {
    "cardAvatar": true,
    "cardAvatarProfile": profile,
    "cardAvatarPlain": plain
  };

  const keyArray = getKeyArray(targetData);

  return (
    <Box sx={getBaseSxStyle(styles, keyArray)} {...rest}>
      {children}
    </Box>
  );
}

CardAvatar.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  profile: PropTypes.bool,
  plain: PropTypes.bool
};
